// Single source of truth for App Store identifiers. ForceUpdateGate and the
// marketing pages all reference these - keep them in sync with the actual
// listing.
export const APP_STORE_ID =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_IOS_APP_STORE_ID) ||
  '6757700146'

export const APP_STORE_WEB_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`
export const APP_STORE_DEEP_LINK = `itms-apps://itunes.apple.com/app/id${APP_STORE_ID}`
